import React, { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { primaryColor } from "assets/jss/material-dashboard-pro-react";
import Button from "components/CustomButtons/Button";
import HTMLEditor from "components/HTMLEditor/HTMLEditor";
import styles from "../ReportStyles.module.css";
import { updateReportBody } from "../reportUtils";

const StudentAdmissions = ({ data, report, setReportBody }) => {
  const [valueContent, setValueContent] = useState(data.description ?? "");

  const handleChangeDescription = (content) => {
    setValueContent(content);
    updateReportBody(
      setReportBody,
      "CRITERION1_STUDENTS",
      "StudentAdmissions",
      "description",
      content
    );
  };

  return (
    <>
      <h3>STUDENTS: Student Admission</h3>

      <p className={styles.reportParagraphTitle}>
        The following is a summary of the process for accepting new students
        into the program:
      </p>
      <HTMLEditor
        valueContent={valueContent}
        setValueContent={handleChangeDescription}
      />
      <br />
      <p className={styles.reportParagraphTitle}>
        The following is the list of the admission requirements for the program:
      </p>
      {/* <GridItem xs={1} sm={1} md={1}>
          <Button
            justIcon
            round
            color="transparent"
            onClick={() => {
              console.log("clicked");
            }}
          >
            <EditIcon />
          </Button>
        </GridItem> */}
      <ul>
        {data?.studentAdmissionRequirements?.map((requirement, index) => (
          <li key={index}>{requirement}</li>
        ))}
      </ul>
    </>
  );
};

export default StudentAdmissions;
